import { useEffect, useState } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { useAccount } from 'wagmi'
import { TENANT_CONFIG } from '@config'
import { useOnboardingStorage } from '@features/onboarding/onboarding.store'
import { useChangeAddressLogout, useLogout, useTokenGating, useViewer } from '@hooks'

const tenatHasTokenGating = TENANT_CONFIG.features?.tokenGating

const useOnboarding = () => {
  const { logout } = useLogout()
  const [isProcessing, setIsProcessing] = useState(true)
  const [checkTokenGating, setCheckTokenGating] = useState(false)
  const navigate = useNavigate()
  const { isConnected } = useAccount()
  const { viewer, status: viewerStatus } = useViewer()
  const userHasCompletedOnboarding = viewer?.isOnboardingCompleted
  const { hasMintedZeekNFT, hasClosedCapsule } = useTokenGating()


  // handle redirection 
  const {state} = useLocation()
  const redirectPath = state?.redirect || '/'
  const { toFinalStep } = useOnboardingStorage()
  useChangeAddressLogout()
  useEffect(() => {
    if (!isConnected || viewer?.isOnboardingCompleted) navigate(redirectPath)
  }, [isConnected])

  useEffect(() => {
    // In this use Effect we check first everything non related to token gating.
    // And if token gating is needed we will trigger the next useEffect
    const isAllInformationAvailable =
      viewer != null && userHasCompletedOnboarding != null && tenatHasTokenGating !== null

    if (viewerStatus === 'error' || (viewerStatus === 'success' && viewer === null)) logout()
    if (isAllInformationAvailable) {
      const mustRedirectToHome = userHasCompletedOnboarding
      const mustLogout = !isConnected

      if (mustRedirectToHome) navigate(redirectPath)
      else if (mustLogout) logout()
      else if (tenatHasTokenGating) setCheckTokenGating(true)
      else {
        // We are here it means no redirection applied and no token
        // gating needed so we can render in the onboarding
        setIsProcessing(false)
      }
    }
  }, [isConnected, viewerStatus, viewer, userHasCompletedOnboarding])

  useEffect(() => {
    const isAllInformationAvailable = hasMintedZeekNFT != null && hasClosedCapsule != null

    if (checkTokenGating && isAllInformationAvailable) {
      const mustRedirectToFinalStep = hasMintedZeekNFT && !userHasCompletedOnboarding
      const mustRedirectToError = !hasClosedCapsule && !hasMintedZeekNFT

      if (mustRedirectToFinalStep) {
        toFinalStep()
      } else if (mustRedirectToError) {
        navigate('/onboarding/error', { replace: true })
      }

      setIsProcessing(false)
    }
  }, [checkTokenGating, hasMintedZeekNFT, hasClosedCapsule, tenatHasTokenGating])

  return { isProcessing, logout }
}

export default useOnboarding
